module.exports = __webpack_public_path__ + "img/lan_tour_route_08.3f6f6491.jpg";